import { Brand, createBranded } from '@deltasierra/type-utilities';

export type LocalMediaPublishId = Brand<
    number,
    'LocalMediaPublishId'
>;
export const LocalMediaPublishId =
    createBranded<LocalMediaPublishId>();
